<template>
  <div class="page-wrapper">
    <nav-header v-if="$route.name=='circleList'" />
    <TabHeader v-else></TabHeader>
    <div class="circles-container" v-infinite-scroll="loadMore" infinite-scroll-distance="10">
      <!-- 左侧内容区 -->
      <div class="content-area">
        <!-- 搜索框 -->
        <div class="search-header">
          <el-input
            v-model="searchKey"
            placeholder="搜索你感兴趣的圈子..."
            class="search-input"
            prefix-icon="el-icon-search"
            @input="handleSearch"
          >
          </el-input>
        </div>

        <!-- 圈子列表 -->
        <div class="circles-list">
          <div class="circle-card" v-for="(item, index) in circles" :key="index">
            <router-link
              class="content-card"
              :to="`/post-list/${item.id}`"
            >
              <div class="circle-content">
                <div class="circle-cover">
                  <el-avatar :size="80" :src="item.avatar"></el-avatar>
                  <div class="circle-type" v-if="item.joinType === 1">
                    <i class="el-icon-lock"></i>付费圈子
                  </div>
                </div>
                <div class="circle-info">
                  <h3 class="title">{{ item.name }}</h3>
                  <p class="description">{{ item.description }}</p>
<!--                  <div class="owner-info">
                    <el-avatar :src="item.ownerAvatar" :size="24"></el-avatar>
                    <span class="owner-name">{{ item.ownerName }}</span>
                  </div>-->
                  <div class="stats">
                    <span class="members">
                      <i class="el-icon-user"></i>
                      {{ item.memberCount }}成员
                    </span>
                    <span class="posts">
                      <i class="el-icon-document"></i>
                      {{ item.postCount }}帖子
                    </span>
                    <span class="time">{{ item.createTime }}</span>
                  </div>
                </div>
              </div>
            </router-link>
            <div class="circle-price" v-if="item.joinType === 1">
              <span class="price">¥{{ item.price }}</span>
              <span class="valid-days">有效期 {{ item.validDays }}天</span>
            </div>
          </div>

          <!-- 加载状态 -->
          <div class="loading-status" v-if="loading || finished">
            <p v-if="loading" class="loading">
              <i class="el-icon-loading"></i> 加载中...
            </p>
            <p v-if="finished" class="no-more">没有更多了</p>
          </div>
        </div>
      </div>

      <!-- 右侧分类导航 -->
      <div class="category-nav">
        <div
          class="nav-item"
          v-for="(item, index) in categories"
          :key="index"
          @click="handleCategoryClick(item)"
          :class="{ active: currentCategory === item.value }"
        >
          <div class="icon-wrapper">
            <i :class="item.icon"></i>
          </div>
          <span class="text">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <!-- 创建圈子按钮 -->
    <el-button
      v-if="userStore.userInfo.id"
      class="create-btn"
      type="primary"
      circle
      @click="createCircle"
    >
      <i class="el-icon-plus"></i>
    </el-button>
  </div>
</template>

<script>
import NavHeader from '@/components/layout/NavHeader.vue'
import _ from 'lodash'
import TabHeader from "@/components/layout/TabHeader.vue";

export default {
  name: 'CircleList',
  
  components: {
    TabHeader,
    NavHeader
  },

  data() {
    return {
      circles: [], // 圈子列表
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      searchKey: '',
      currentCategory: '',
      categories: []
    }
  },

  created() {
    this.getCircleList()
    // 获取分类列表
    this.$http2({
      url: `/system/dict/data/list?dictType=creation_category`,
      method: 'get',
    }).then((data) => {
      data.rows.forEach((item) => {
        this.categories.push({
          name: item.dictLabel,
          value: item.dictValue,
          icon: item.cssClass
        })
      })
    })
  },

  methods: {
    // 加载更多
    loadMore() {
      if (this.loading || this.finished) return
      this.page++
      this.getCircleList()
    },

    // 获取圈子列表
    async getCircleList() {
      try {
        this.loading = true
        const res = await this.$http2({
          method: 'get',
          url: `/klgeek/circle/list`,
          params: {
            pageNum: this.page,
            pageSize: this.pageSize,
            name: this.searchKey,
            // category: this.currentCategory
          }
        })

        this.circles = [...this.circles, ...res.rows]

        if (res.total <= this.circles.length) {
          this.finished = true
        }
      } catch (error) {
        console.error('获取圈子列表失败:', error)
      } finally {
        this.loading = false
      }
    },

    // 重置列表
    resetList() {
      this.circles = []
      this.page = 1
      this.finished = false
      this.getCircleList()
    },

    // 搜索处理
    handleSearch: _.debounce(function() {
      this.resetList()
    }, 300),

    // 分类点击处理
    handleCategoryClick(category) {
      if (this.currentCategory === category.value) {
        this.currentCategory = ''
      } else {
        this.currentCategory = category.value
      }
      this.resetList()
    },

    // 创建圈子
    createCircle() {
      this.$router.push('/home/community/circle-detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  min-height: 100vh;
  background: #f5f6f7;
  padding-bottom: 40px;
  width: 100%;
}

.circles-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  display: flex;
  gap: 20px;
  width: 100%;
  box-sizing: border-box;
  justify-content: center;
  .content-area {
    flex: 1;
    min-width: 0;

    .search-header {
      margin-bottom: 20px;

      .search-input {
        width: 100%;
        max-width: 500px;
      }
    }

    .circles-list {
      .circle-card {
        background: #fff;
        border-radius: 12px;
        margin-bottom: 20px;
        display: flex;
        overflow: hidden;
        transition: all 0.3s ease;
        border: 1px solid #eee;

        &:hover {
          transform: translateY(-4px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
        }

        .content-card {
          flex: 1;
          padding: 20px;
          text-decoration: none;
          color: inherit;

          .circle-content {
            display: flex;
            gap: 20px;

            .circle-cover {
              position: relative;
              flex-shrink: 0;

              .circle-type {
                position: absolute;
                bottom: -8px;
                left: 50%;
                transform: translateX(-50%);
                background: #ff6b00;
                color: #fff;
                font-size: 12px;
                padding: 2px 10px;
                border-radius: 10px;
                white-space: nowrap;
                display: flex;
                align-items: center;
                gap: 4px;
              }
            }

            .circle-info {
              flex: 1;
              min-width: 0;

              .title {
                font-size: 18px;
                color: #333;
                margin: 0 0 8px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .description {
                color: #666;
                font-size: 14px;
                margin: 0 0 12px;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }

              .owner-info {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 12px;

                .owner-name {
                  font-size: 14px;
                  color: #666;
                }
              }

              .stats {
                display: flex;
                gap: 16px;
                color: #999;
                font-size: 13px;

                span {
                  display: flex;
                  align-items: center;
                  gap: 4px;
                }

                .time {
                  color: #666;
                }
              }
            }
          }
        }
        .loading-status {
          text-align: center;
          padding: 20px 0;
          color: #999;
          font-size: 14px;

          .loading {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 8px;
          }

          .no-more {
            color: #999;
          }
        }
        .circle-price {
          padding: 20px;
          border-left: 1px solid #eee;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .price {
            color: #ff4d4f;
            font-size: 20px;
            font-weight: 600;
            margin-bottom: 4px;
          }

          .valid-days {
            color: #999;
            font-size: 12px;
          }
        }
      }
    }
  }

  .category-nav {
    width: 100px;
    background: #fff;
    border-radius: 12px;
    padding: 16px;
    position: sticky;
    top: 84px;
    height: fit-content;

    .nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 12px 0;
      cursor: pointer;
      transition: all 0.3s ease;
      
      &:hover {
        color: #ff6b00;
      }
      
      &.active {
        color: #ff6b00;
        background: rgba(255, 107, 0, 0.1);
        border-radius: 6px;
      }

      .icon-wrapper {
        font-size: 24px;
        margin-bottom: 4px;
      }

      .text {
        font-size: 14px;
      }
    }
  }
}

.create-btn {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 50px;
  height: 50px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

// 响应式适配
@media screen and (max-width: 768px) {
  .circles-container {
    flex-direction: column;
    padding: 16px;

    .category-nav {
      width: 100%;
      order: -1;
      position: sticky;
      top: 60px;
      margin-bottom: 16px;
      padding: 12px;
      display: flex;
      overflow-x: auto;
      
      &::-webkit-scrollbar {
        display: none;
      }

      .nav-item {
        width: auto;
        min-width: 60px;
        padding: 8px 12px;
        flex-shrink: 0;
        
        &.active {
          border-radius: 20px;
        }
      }
    }

    .circles-list {
      .circle-card {
        .content-card {
          padding: 16px;

          .circle-content {
            gap: 16px;

            .circle-info {
              .title {
                font-size: 16px;
              }

              .description {
                font-size: 13px;
                margin-bottom: 10px;
              }

              .stats {
                font-size: 12px;
                gap: 12px;
              }
            }
          }
        }

        .circle-price {
          padding: 16px;
        }
      }
    }
  }

  .create-btn {
    right: 20px;
    bottom: 20px;
  }
}
</style> 